import { render, staticRenderFns } from "./CommercialLeadListDetails.vue?vue&type=template&id=44bc5c96&"
import script from "./CommercialLeadListDetails.vue?vue&type=script&lang=js&"
export * from "./CommercialLeadListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports